import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, smallElevation } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = theme;

const FADE_WIDTH_PX = 32;
const ARROW_SIZE_PX = 40;

export const nav = css`
  display: flex;
  align-items: center;
  column-gap: ${spacing.sm}px;
  min-width: 0;
`;

export const viewport = css`
  position: relative;
  flex: 1;
  min-width: 0;
`;

export const scrollContainer = css`
  overflow-x: auto;
  scroll-behavior: smooth;
  /* Hide the native scrollbar — scrolling is via swipe (touch) or the arrows. */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const fade = css`
  position: absolute;
  top: 0;
  bottom: 0;
  width: ${FADE_WIDTH_PX}px;
  pointer-events: none;
`;

export const fadeLeft = css`
  ${fade};
  left: 0;
  background: linear-gradient(to right, var(${themeVariables.colors.page.default}), transparent);
`;

export const fadeRight = css`
  ${fade};
  right: 0;
  background: linear-gradient(to left, var(${themeVariables.colors.page.default}), transparent);
`;

export const arrow = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: ${ARROW_SIZE_PX}px;
      height: ${ARROW_SIZE_PX}px;
      padding: 0;
      border-radius: 50%;
      border: 1px solid transparent;
      background: var(${themeVariables.colors.surface.default});
      color: var(${themeVariables.colors.content.default});
      cursor: pointer;
      ${smallElevation};

      &:hover {
        border-color: var(${themeVariables.colors.stroke.interactive});
      }
    `,
  )}
`;
